import NamedResource from "./namedResource";
import {Permission} from "./permission";

export class UserRoleResource extends NamedResource {
    Description: string;
    SupportedRestrictions: string[];
    PermissionDescriptions: string[];
    CanBeDeleted: boolean;
    GrantedPermissions: Permission[];
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/resources/userRoleResource.ts